import { render, staticRenderFns } from "./ViewEdit.vue?vue&type=template&id=46509f08&scoped=true"
import script from "./ViewEdit.vue?vue&type=script&lang=ts"
export * from "./ViewEdit.vue?vue&type=script&lang=ts"
import style0 from "./ViewEdit.vue?vue&type=style&index=0&id=46509f08&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46509f08",
  null
  
)

export default component.exports